import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ArrowRight, Loader2 } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL ? `${process.env.REACT_APP_BACKEND_URL}/api` : null;

export const NewsletterForm = () => {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!API) { toast.error("Subscriptions are unavailable right now."); return; }
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/newsletter`, { email });
      toast.success(data?.already ? "You're already on the list." : "Subscribed — new issues will reach your inbox.");
      setEmail("");
    } catch {
      toast.error("Please enter a valid email address.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} className="flex items-center border-b border-[var(--paper)]/40 focus-within:border-[var(--paper)] transition-colors" data-testid="newsletter-form">
      <label htmlFor="newsletter-email" className="sr-only">Email address</label>
      <input id="newsletter-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Your email address" className="flex-1 bg-transparent py-4 text-lg text-[var(--paper)] placeholder:text-[#B9C4BC] outline-none" data-testid="newsletter-email-input" />
      <button type="submit" disabled={busy} aria-label="Subscribe" className="w-12 h-12 grid place-items-center rounded-full bg-[var(--paper)] text-[var(--emerald)] hover:bg-[var(--gold)] transition-colors disabled:opacity-60" data-testid="newsletter-submit-button">
        {busy ? <Loader2 className="w-5 h-5 animate-spin" /> : <ArrowRight className="w-5 h-5" />}
      </button>
    </form>
  );
};
